import { ApolloCache, DefaultContext, MutationHookOptions } from '@apollo/client'
import { useCallback } from 'react'

import { CountProductIdeasDocument, useDeleteFeedbackPostAsAdminMutation } from '~generated/hooks'
import { DeleteFeedbackPostAsAdminMutation } from '~generated/operations'
import { Exact } from '~generated/types'
import { feedbackPostTypename } from '~lib/apollo/typenames'

export default function useDeleteFeedbackPost(
  baseOptions?: MutationHookOptions<
    DeleteFeedbackPostAsAdminMutation,
    Exact<{ id: string }>,
    DefaultContext,
    ApolloCache<any>
  >
) {
  const [deleteFeedbackPostMutation, options] = useDeleteFeedbackPostAsAdminMutation(baseOptions)

  const deleteFeedbackPost = useCallback(
    (id: string) => {
      deleteFeedbackPostMutation({
        refetchQueries: [CountProductIdeasDocument],
        awaitRefetchQueries: true,
        variables: { id },
        update: (cache, result) => {
          if (result?.data) {
            cache.evict({ id: cache.identify({ id, __typename: feedbackPostTypename }) })
            cache.gc()
          }
        },
      })
    },
    [deleteFeedbackPostMutation]
  )

  return [deleteFeedbackPost, options] as const
}
